/** Marketing-site path for invite-only access messaging */
export const INVITE_ONLY_PATH = '/invite';
